import { useEffect, useState, useCallback } from "react";
import { Bell } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { api, dt } from "@/lib/api";

const SEV = { critical: "bg-red-500", warning: "bg-amber-500", info: "bg-cyan-500" };

export default function Notifications() {
  const [data, setData] = useState({ items: [], unread: 0 });
  const load = useCallback(async () => {
    try {
      const r = await api.get("/notifications", { params: { limit: 40 } });
      setData(r.data);
    } catch {}
  }, []);
  useEffect(() => {
    load();
    const t = setInterval(load, 20000);
    return () => clearInterval(t);
  }, [load]);
  const read = async (n) => {
    if (!n.read) await api.post(`/notifications/${n.id}/read`);
    load();
  };
  return (
    <Popover onOpenChange={(o) => o && load()}>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="icon" className="relative" data-testid="notifications-bell">
          <Bell className="h-4 w-4" />
          {data.unread > 0 && (
            <span data-testid="notifications-unread" className="absolute -right-0.5 -top-0.5 min-w-[18px] rounded-full bg-red-500 px-1 text-center font-mono text-[10px] font-bold text-white">
              {data.unread > 99 ? "99+" : data.unread}
            </span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-[340px] bg-popover p-0 sm:w-[400px]">
        <div className="flex items-center justify-between border-b px-4 py-3">
          <span className="font-display text-sm font-bold">Notifications</span>
          <button data-testid="notifications-read-all" className="text-xs text-primary hover:underline" onClick={async () => { await api.post("/notifications/read-all"); load(); }}>
            Mark all read
          </button>
        </div>
        <div className="max-h-[420px] overflow-y-auto" data-testid="notifications-list">
          {!data.items.length && <div className="p-6 text-center text-sm text-muted-foreground">No notifications</div>}
          {data.items.map((n) => (
            <button key={n.id} onClick={() => read(n)} className={`flex w-full gap-3 border-b border-border/40 px-4 py-3 text-left hover:bg-muted/40 ${n.read ? "opacity-60" : ""}`}>
              <span className={`mt-1.5 h-2 w-2 shrink-0 rounded-full ${SEV[n.severity] || "bg-slate-500"}`} />
              <span className="min-w-0">
                <span className="block text-sm font-semibold leading-snug">{n.title}</span>
                <span className="block truncate text-xs text-muted-foreground">{n.message}</span>
                <span className="font-mono text-[10px] text-muted-foreground">{dt(n.at)}</span>
              </span>
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
